module.exports = __webpack_public_path__ + "static/media/avatar-empty.d978ae29.jpg";